export default __webpack_public_path__ + "static/media/Amazon_Logo.f88d7386.svg";